/** Insights' words for its figures: numbers with their units, and a missing figure said as missing, never 0. */
import { kmText, type InsightsQc, type InsightsRate } from '@teslyn/domain';

export const kmOf = kmText;

const fixed = (v: number, digits: number): string =>
  v.toLocaleString('en-AU', { minimumFractionDigits: digits, maximumFractionDigits: digits });

/** "1,399.9 km", or an en dash with nothing to divide by. */
export const kmPerText = (v: number | null): string => (v === null ? '–' : `${fixed(v, 1)} km`);

/** "187.4 km/h", or an en dash. */
export const kmPerHourOneText = (v: number | null): string => (v === null ? '–' : `${fixed(v, 1)} km/h`);

/** "0.26 %", or an en dash with nothing flown. */
export const percentText = (v: number | null, digits = 2): string =>
  v === null ? '–' : `${fixed(v, digits)} %`;

/** "99.6 % (477 of 479 lines)", or an en dash with no line reviewed. */
export function rateText(r: InsightsRate): string {
  return r.pct === null ? '–' : `${percentText(r.pct, 1)} (${r.count} of ${r.of} lines)`;
}

/** QC's figure: what ran, or that it did not, or that it could not be read. Never a zero for either. */
export function qcText(q: InsightsQc): string {
  if (q.state === 'not_read') return 'Could not be read';
  if (q.state === 'not_run') return 'QC not run';
  const part = q.lines < q.ofLines ? `, QC on ${q.lines} of ${q.ofLines} lines` : '';
  return `${percentText(q.pct, 1)} (${q.pass} of ${q.lines} lines${part})`;
}

/** "Flew on 9 of 12 days" (decision 228: days, not a percentage), or an en dash. */
export const aircraftUseText = (
  u: { readonly flyingDays: number; readonly projectDays: number } | null,
): string => (u === null || u.projectDays <= 0 ? '–' : `Flew on ${u.flyingDays} of ${u.projectDays} days`);
